import React from "react";
import { withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import MeetingRoomIcon from "@material-ui/icons/MeetingRoom";

const useStyles = (theme) => ({
  title: {
    flexGrow: 1,
  },
  spaceBelow: {
    marginBottom: theme.spacing(1),
  },
  link: {
    textDecoration: "none",
  },
});

class Header extends React.Component {
  render() {
    const { classes, handleLogout } = this.props;

    return (
      <AppBar position="static" className={classes.spaceBelow}>
        <Toolbar>
          <Typography variant="caption" className={classes.title}>
            s n o b i f y
          </Typography>
          <Tooltip title="Logout">
            <IconButton
              onClick={(e) => {
                localStorage.removeItem("spotify_auth_access_token");
                localStorage.removeItem("spotify_auth_refresh_token");
                localStorage.removeItem(
                  "spotify_auth_access_token_expiry_date"
                );
                handleLogout();
              }}
            >
              <MeetingRoomIcon />
            </IconButton>
          </Tooltip>
        </Toolbar>
      </AppBar>
    );
  }
}

export default withStyles(useStyles)(Header);
